import { Component } from '@angular/core';
import { ChildrenOutletContexts } from '@angular/router';

@Component({
	selector: 'app-layout',
	templateUrl: './layout.component.html',
	styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent {

	constructor(private contexts: ChildrenOutletContexts) {
	}
}
